import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { scrollIntoChoice } from "./ModalChoices.helper";
import SingleChoice from "./SingleChoice";

const ModalScrollableChoices = ({
  value = "",
  choices = [],
  onChange = () => {},
  onClose = () => {},
}) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(value);

  const onConfirm = () => {
    onChange(selectedValue);
    onClose();
  };

  // scroll into selected choice (if any) on mount
  useEffect(() => scrollIntoChoice(value), []);

  return (
    <Modal
      open={true} // this component has a state so its visibility is managed by the parent
      title={t("form:choicesDialog.title", { count: choices.length })}
      okText={t("global:confirm")}
      cancelText={t("global:cancel")}
      onCancel={onClose}
      onOk={onConfirm}
      okButtonProps={{ disabled: !selectedValue }}
      mask={{ closable: false }}
    >
      <div className="modal-scrollable-choices">
        {choices.map((choice) => (
          <SingleChoice
            key={choice.value}
            choice={choice}
            isChecked={choice.value === selectedValue}
            onSelection={setSelectedValue}
          />
        ))}
      </div>
    </Modal>
  );
};

export default ModalScrollableChoices;
